import { useField, Field } from 'formik';
import type { ICheckboxInput } from '../types';
import * as s from './styles/checkbox.module.css';

import FormText from '@klv/atoms/form-text';

const CheckboxInput = ({ id, className, label, backgroundColor = 'dark', size = 'medium',   disabled = 'enabled', showError = true, dangerouslySetHTML,  ...props }: ICheckboxInput) => {
  const [_field, meta] = useField(props);

  const hasError = meta.touched && meta.error;

  return (
    <div className={`${s.checkbox} ${s[backgroundColor]} ${s[disabled]} ${s[size]}`}>
      <div className={s.checkboxContainer}>
        <Field type="checkbox" id={id} name={props.name} value={props.value} />
        <label className={`${s.checkboxLabel} ${hasError ? s.error : ''}`} htmlFor={id}></label>
        {dangerouslySetHTML ? <label className={className} htmlFor={id} dangerouslySetInnerHTML={{ __html: label as string }}/> : <label className={className} htmlFor={id}>{label}</label>}
      </div>
      {showError && (meta.touched && meta.error) && <FormText className={s.error}>{meta.error}</FormText>}
    </div>
  );
};

export default CheckboxInput;
